import { c as _c } from "react/compiler-runtime";
import { Box, type BoxProps } from '@mui/material';
export const Badge = props => {
  const $ = _c(11);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fill="none" d="M108.59 217.18h-.03.04-.01m0 0h-.03.04-.01" />;
    t1 = <path fill="#00ae4d" d="M107.92.64a10 10 0 0 0-3.51-.64H7.15A7.15 7.15 0 0 0 0 7.15v101.44z" />;
    t2 = <path fill="none" d="M108.59 217.18h-.03.04-.01" />;
    t3 = <path fill="#00ae4d" d="M2.09 323.67a7.13 7.13 0 0 0 5.06 2.09h94.29a7.15 7.15 0 0 0 7.15-7.15V217.18z" />;
    t4 = <path fill="#00682c" d="M217.17 108.59v216.29l.65.27 107.94-107.97z" />;
    t5 = <path fill="none" d="M108.59 217.18h-.03.03" />;
    t6 = <path fill="#8ccb32" d="M108.59 217.18V.88c-.21-.1-.43-.2-.65-.28L0 108.59v210a7.13 7.13 0 0 0 2.09 5.05zm217.17 0V7.15A7.15 7.15 0 0 0 318.61 0h-94.29a7.15 7.15 0 0 0-7.15 7.14v101.45zm0 0L217.82 325.12a10 10 0 0 0 3.51.64h97.29a7.15 7.15 0 0 0 7.15-7.15V217.18z" />;
    t7 = <path fill="#d0d1d3" d="M108.6 217.18h-.01.01m108.58-108.59" />;
    t8 = <path fill="#00ae4d" d="M111.52 2.93a9.94 9.94 0 0 0-2.94-2v216.25l105.66 105.65a10 10 0 0 0 2.94 2V108.59z" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] !== props) {
    t9 = <Box data-testid="nw-logo-n-header" component="svg" height="27px" width="27px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 325.76 325.77" aria-labelledby="nav__logo-short__title__footer" {...props}>{t0}{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}</Box>;
    $[9] = props;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  return t9;
};